import axios from 'axios'
import {server} from '../../functions/host';

export const createOrUpdateUser = async (user, authtoken) =>{  
    //sending in the headers not body
    return await axios.post( `${server}/api/create-or-update-user`, user, {  
        headers:{ 
            authtoken:authtoken
        }
    });
}

export const verifyUser = async (user) =>{  
    return await axios.post( `${server}/api/sendverify`, {userEmail:user, redirectUrl:process.env.REACT_APP_FORGOT_PASSWORD_REGISTER_REDIRECT_URL});
}

export const updateUser = async (number, authtoken) =>{  
    //sending in the headers not body
    return await axios.post( `${server}/api/update-user`, number, {  
        headers:{ 
            authtoken:authtoken
        }
    });
}


export const createAdmin = async (admin, authtoken) =>{  
    //sending in the headers not body
    return await axios.post( `${server}/api/create-admin`, admin, {  
        headers:{ 
            authtoken:authtoken
        }
    });
}


export const createBobza = async (bobza, authtoken) =>{  
    //sending in the headers not body
    return await axios.post( `${server}/api/create-bobza`, bobza, {  
        headers:{ 
            authtoken:authtoken
        }
    });
}



export const currentUser = async (authtoken) =>{  
    //sending in the headers not body
    return await axios.post( `${server}/api/current-user`, {}, {  
        headers:{ 
            authtoken:authtoken
        },
    });
}



export const currentAdmin = async (authtoken) =>{  
    //sending in the headers not body
    return await axios.post( `${server}/api/current-admin`, {}, {  
        headers:{ 
            authtoken:authtoken
        },
    });
}



export const currentBobza = async (authtoken) =>{  
    //sending in the headers not body
    return await axios.post( `${server}/api/current-bobza`, {}, {  
        headers:{ 
            authtoken:authtoken
        },
    });
}



